import filters from '@/mixins/filters.js';

function createDataOverview() {
  return {
    data() {
      return {
        googleadvertising: {},
      };
    },
    methods: {
      setFBadvertising(val = {}) {
        const { googleAdsBaseReport } = val;
        const that = this;
        this.googleadvertising = {
          list: [
            {
              id: 1,
              title: '展示次数',
              icon: 'zhanshicishu',
              iconStyle: { color: '#93f4fd' },
              iconBgc: { backgroundColor: '#d3fbff' },
              data: filters.filters.thousands(
                that.hasProperty(googleAdsBaseReport, 'impressions')
              ),
              rate:
                filters.filters.number(
                  Math.abs(
                    that.hasProperty(
                      googleAdsBaseReport,
                      'impressionsRingRatio'
                    ) || 0
                  )
                ) + '%',
              state: that.hasProperty(
                googleAdsBaseReport,
                'impressionsRingRatio'
              ),
              message: {
                site: 'top-start',
                content: `广告在屏幕上展示的次数。`,
              },
            },
            {
              id: 2,
              title: '成效',
              icon: 'chengxiao',
              iconStyle: { color: '#abedd9' },
              iconBgc: { backgroundColor: '#e6fdf6' },
              data: filters.filters.thousands(val.effect),
              rate:
                filters.filters.number(Math.abs(val.effectRingRatio || 0)) +
                '%',
              state: val.effectRingRatio,
              tooltipData: val.effectGroupMap,
              message: {
                site: 'right-end',
                content: `
                  根据选中目标和设置，广告实现成效的次数。
                  如目标为“流量”，则成效为“链接点击”
                  目标为“主页赞”，则成效为“赞”`,
                subtitle: '如“点击量”等指标',
              },
            },
            {
              id: 3,
              title: '成效获得率',
              icon: 'chengxiaohuodeshuai',
              iconStyle: { color: '#ef929c' },
              iconBgc: { backgroundColor: '#fff5f4' },
              data: filters.filters.jojint(val.effectiveRate),
              rate:
                filters.filters.number(
                  Math.abs(val.effectiveRateRingRatio || 0)
                ) + '%',
              state: val.effectiveRateRingRatio,
              message: {
                site: 'top-start',
                content: `获得的成效在所有广告查看量中所占的百分比。广告系列成效之和/总展现*100%`,
              },
            },
            {
              id: 4,
              title: '覆盖人数',
              icon: 'fugairenshu2',
              iconStyle: { color: '#92cefa' },
              iconBgc: { backgroundColor: '#ecf5fb' },
              data: filters.filters.thousands(val.covers),
              rate:
                filters.filters.number(Math.abs(val.coversRingRatio || 0)) +
                '%',
              state: val.coversRingRatio,
              message: {
                site: 'top-start',
                content: `至少查看广告一次的用户数量。覆盖人数与展示次数不同，后者可能存在同一用户多次浏览广告的情况。此处未对同一用户多天浏览广告的情况进行过滤`,
              },
            },
            {
              id: 5,
              title: '总消耗（元）',
              icon: 'zongxiaohao1',
              iconStyle: { color: '#abbeef' },
              iconBgc: { backgroundColor: '#edf0f6' },
              data: filters.filters.rmb(
                that.hasProperty(googleAdsBaseReport, 'exchangeRateCost')
              ),
              rate:
                filters.filters.number(
                  Math.abs(
                    that.hasProperty(
                      googleAdsBaseReport,
                      'exchangeRateCostRingRatio'
                    ) || 0
                  )
                ) + '%',
              state: that.hasProperty(
                googleAdsBaseReport,
                'exchangeRateCostRingRatio'
              ),
              message: {
                site: 'top-start',
                content:
                  '筛选时间周期内总支出，美金结算，以消耗当天汇率换算人民币',
              },
            },
          ],
          title: '数据总览',
          type: 'google',
          bottom: true,
        };
      },
      hasProperty(obj, property) {
        if (!property || !obj) return;
        if (obj.hasOwnProperty(property)) return obj[property];
        return;
      },
    },
  };
}

export default createDataOverview;
